import { createEffect } from 'solid-js';
import { date } from 'common';
import { Dropdown, requireAttendanceGridContext } from '../../..';
import { requireDropdownContext } from 'common';
import { MiniNavigation, MiniCalendar } from './MiniCalendar';
import styles from '../st-attendance-grid.module.css';

const { startOfWeek, endOfWeek, addDays, shortMonthName } = date;

export function WeekSelector() {
    const ctx = requireAttendanceGridContext();

    const label = () => {
        const day = ctx.day();
        const weekStart = addDays(startOfWeek(day), 1); // Monday
        const weekEnd = addDays(startOfWeek(day), 5);   // Friday
        return `${shortMonthName(weekStart)} ${weekStart.getDate()} - ${shortMonthName(weekEnd)} ${weekEnd.getDate()}, ${weekEnd.getFullYear()}`;
    };

    return (
        <Dropdown>
            <Dropdown.Trigger>
                <span class={styles['week-selector-trigger']}>
                    <i class="fa fa-calendar" />
                    {label()}
                    <i class="fa fa-chevron-down" />
                </span>
            </Dropdown.Trigger>
            <Dropdown.Content>
                <WeekSelectorContent />
            </Dropdown.Content>
        </Dropdown>
    );
}

function WeekSelectorContent() {
    const ctx = requireAttendanceGridContext();
    const ddCtx = requireDropdownContext();

    let prevDay = ctx.day();
    createEffect(() => {
        const currentDay = ctx.day();
        if (currentDay !== prevDay) {
            ddCtx.setIsOpen(false);
            prevDay = currentDay;
        }
    });

    return (
        <div class={styles['week-selector-content']}>
            <MiniNavigation />
            <MiniCalendar />
        </div>
    );
}
